/*
Special note:
As the donation modules can't be used as a source of valid data, we need a seperate validation module.
Ideally all of these should have been handled at the component level (by vue-formulate),
but as the form is made up of multiple dynamic components, it will introduce a new layer of complexity
so for now at least we should handle all the validation stuff here.
!TODO: the main validator function should also return detailed errors
*/

import store from '@/store';

import { MAX_AMOUNT, sentryMessage } from '@/utils';

export const state = {
  isCustomQuestionsValid: true, // will be set to false in custom-questions.vue if needed
  isPaymentDetailsValid: false,
  isPhoneValid: false
};

export const mutations = {
  SET_IS_CUSTOM_QUESTIONS_VALID(state, newValue) {
    state.isCustomQuestionsValid = newValue;
  },
  SET_IS_PAYMENT_DETAILS_VALID(state, newValue) {
    state.isPaymentDetailsValid = newValue;
  },
  SET_IS_PHONE_VALID(state, newValue) {
    state.isPhoneValid = newValue;
  }
};

export const getters = {
  // Step 1
  isAmountValid(state, getters, rootState, rootGetters) {
    const amount = rootState.donation.amount;
    
    // Campaign-level setting overrides org-level setting
    let minimumDonationAmount;
    const campaignMinimum = rootState.campaign?.settings?.minimumDonationAmount;
    
    if (campaignMinimum != null) {
      minimumDonationAmount = Number(campaignMinimum);
    } else {
      minimumDonationAmount = rootGetters['publicOrgSettings/minimumDonationAmount'];
    }
    
    const isValid = !isNaN(amount) && amount >= minimumDonationAmount && amount <= MAX_AMOUNT;
    return isValid;
  },

  // Step 2
  isOftenValid(state, _, rootState) {
    const donation = rootState.donation;
    const oftenValue = donation.frequency;
    const isFrequencyValid = ['single', 'daily', 'weekly', 'monthly', 'yearly'].includes(oftenValue);
    if (!isFrequencyValid) {
      return false;
    }

    return true;
  },

  isPaymentDetailsValid(state) {
    return state.isPaymentDetailsValid;
  },

  // Custom questions validity (used by Additional Details screen)
  isCustomQuestionsValid(state) {
    return state.isCustomQuestionsValid;
  },

  // Getters
  isFirstStepValid(state, getters) {
    // First step only validates amount and frequency (custom questions moved to Additional Details screen)
    return getters.isAmountValid && getters.isOftenValid;
  },

  isDonationValid(_, getters) {
    // Validate only the essential fields from the first step and all fields from the second step.
    // This ensures that any bug allowing a user to bypass required fields in the first step
    // does not prevent them from completing the donation.
    if (!getters.isFirstStepValid) {
      sentryMessage(`Donor reached 2'nd step with invalid 1'st step!?`, 'warning', {
        name: 'Store',
        data: { validation: store.state.validation, donation: store.state.donation }
      });
    }
    return getters.isAmountValid && getters.isOftenValid && getters.isPaymentDetailsValid;
  }
};
